// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Slider__Wrapper_2TD96","Title":"Slider__Title_20IW5"};